module.exports = __webpack_public_path__ + "static/media/2 viking norse bearded warrior fullsleeve tattoo .1280x2612.2dc281aa.webp";